import { memo } from "react";
import { SonicImage } from "@discovery/components-luna/lib/components/atoms/image";
import { cn } from "@discovery/classnames";
import * as M from "@discovery/prelude/lib/data/maybe";
import { SonicImageDplus } from "../../../../atoms/sonic-image";
import { Typography, HeaderVariants, Tags } from "../../../../atoms/typography";
import { PlaceholderImage } from "../../../../atoms/placeholder-image";
import { Link } from "../../../../atoms/link";
import { getIsMobile } from "../../../../../utils/isMobile";
import * as styles from "./styles.css";
export const PortraitCard = memo(({ image, name, route }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.categoryWrapper, id: "#superStarD" },
            React.createElement(Link, { href: route },
                React.createElement("div", { className: cn(styles.thumbnailPortraitContainer, {
                        [styles.hoverable]: !getIsMobile(),
                    }) },
                    React.createElement("div", { className: cn(styles.hoverOverlay, styles.portaraitHoverOverlay) },
                        React.createElement("div", { className: styles.content },
                            React.createElement(Typography, { variant: HeaderVariants.subHeadOne, tag: Tags.p, classNameM: M.of(styles.potraitName) },
                                React.createElement(React.Fragment, null, name)))),
                    React.createElement("div", { className: styles.thumbnailPortaitImageContainer },
                        React.createElement("div", { className: styles.thumbnailPortraitImageWrapper },
                            React.createElement(PlaceholderImage, null),
                            image && ( // TODO
                            React.createElement(SonicImage, { image: image, imageSizes: {
                                    default: [100, "vw"],
                                    maxWidthMediaQueries: [
                                        [699, "px", 120, "px"],
                                        [1023, "px", 140, "px"],
                                        [1439, "px", 180, "px"],
                                        [2559, "px", 200, "px"],
                                    ],
                                }, extraImageWidths: [320, 480, 700], className: styles.thumbnailImage, fallbackImageSize: { width: 360 }, alt: "" }))))))),
        React.createElement("div", { className: styles.potraitContainer, id: "#superStarM" },
            React.createElement(Link, { href: route },
                React.createElement(PlaceholderImage, null),
                React.createElement(SonicImageDplus, { src: image.src, quality: 75, className: styles.portraitImg, width: 300 })),
            React.createElement(Typography, { variant: HeaderVariants.subHeadOne, tag: Tags.p, classNameM: M.of(styles.potraitName) },
                React.createElement(React.Fragment, null, name)))));
});

